import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Content from 'components/shared/Content'
import Map from 'components/shared/Map'
import GoogleMap from 'components/shared/Map/GoogleMap'
import Battery from 'components/shared/Battery'
import ReadIcon from 'components/shared/ReadIcon'
import Gauge from 'components/shared/Gauge'
import Order from 'components/Page/Tank/Order'
import { toTitleCase, dateString, normaliseID } from 'utils/common'
import { API } from 'aws-amplify'
import { ITank } from 'types'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Button from '@material-ui/core/Button'
import { TRACKERTYPES, MOVABLETYPES } from 'utils/constants'
import dateformat from 'dateformat'
import { borderRadius } from '@material-ui/system';
interface Props {
  tank: ITank
  geo: any
}


const Current = ({ tank, geo }: Props) => {
  let lastUpdated = 0
  const [state, setState] = React.useState({
    type: '',
    age: '',
    day: '',
    name: 'hai',
    geo,
    deviceID: '',
    // startDate: '',
    // endDate: '',
    startSelected: '',
    endSelected: '',
    startDate: 0,
    endDate: 0,
    earlyDate: 0,
    lateDate: 0,
    durationDate: 0,
    selectedDate: '',
    backgroundColorDuration: '#F4BFC1',
    backgroundColorOneDay: '#F4BFC1',
    backgroundColorDateRange: '#F4BFC1',
    isDisableSearchDuration: true,
    isDisableSearchOneDay: true,
    isDisableSearchDateRange: true
  });
  //const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [noRecords, setError] = React.useState(false);



  const resetColor = backgroundColor => event => {
    setState({
      ...state,
      [backgroundColor]: '#e20015'
    })
  }

  const mouseOverColor = backgroundColor => event => {
    setState({
      ...state,
      [backgroundColor]: '#DA8B8E'
    })
  }


  const btnReloadPage = () => {
    setError(false);
    setState({
      ...state,
      geo

    })
  }
  //Button click - Search by duration
  const btnSearchByDuration = () => {
    var today = new Date();
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    let late_night = date + ' 23:59:59';
    let late_datetimeparts = late_night.split(' ');
    let late_timeParts = late_datetimeparts[1].split(':');
    let late_dateParts = late_datetimeparts[0].split('-');
    let late_date = new Date(parseInt(late_dateParts[0]), parseInt(late_dateParts[1], 10) - 1, parseInt(late_dateParts[2]), parseInt(late_timeParts[0]), parseInt(late_timeParts[1]));

    var todaydate = late_date.getTime();
    const body = {
      "did": state.deviceID,
      "start_date": state.durationDate,
      "end_date": todaydate
    }
    // let selectedDate = event.target.value;
    API.post('BOC_API', '/searchlatlong', {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }, body
    }).then(function (response) {
      if (response !== undefined) {
        let getLocations = response;
        if (getLocations.data.Items.length > 0) {
          for (var j = 0; j < getLocations.data.Items.length; j++) {
            Object.assign(getLocations.data.Items[j], { tank: tank });
          }
          setError(false);
          setState({
            ...state,
            //[name]: state.selectedDate,
            geo: getLocations.data.Items,
            backgroundColorDuration: '#e20015'
          })
        }
        else {
          setError(true);
        }
      }

    });
  }

  // Search by one day- Button click
  const btnSearchSingleDay = () => {
    const body = {
      "did": state.deviceID,
      "start_date_time": state.earlyDate,
      "end_date_time": state.lateDate
    }

    API.post('BOC_API', '/locationsearchbydate', {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }, body
    }).then(function (response) {
      let getLocations = response;
      console.log('date range - one day' + JSON.stringify(response));
      if (getLocations.data.Items.length > 0) {
        for (var j = 0; j < getLocations.data.Items.length; j++) {
          Object.assign(getLocations.data.Items[j], { tank: tank });
        }
        setError(false);
        setState({
          ...state,
          geo: getLocations.data.Items,
          backgroundColorOneDay: '#e20015',
        })
      }
      else {
        setError(true);
      }
    });
  }

  // Search By Date Range - Button click - Search by date range (from Date-To Date) 
  const btnSearchBydateRange = () => {
    const body = {
      "did": tank.deviceID,
      "start_date": state.startDate,
      "end_date": state.endDate
    }

    API.post('BOC_API', '/searchlatlong', {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }, body
    }).then(function (response) {
      let getLocations = response;
      console.log('date range' + JSON.stringify(response));
      if (getLocations.data.Items.length > 0) {
        for (var j = 0; j < getLocations.data.Items.length; j++) {
          Object.assign(getLocations.data.Items[j], { tank: tank });
        }
        setError(false);
        setState({
          ...state,
          geo: getLocations.data.Items,
          backgroundColorDateRange: '#e20015'
        })
      }
      else {
        setError(true);
      }
    });
  };

  // Duration date change
  const handleChange = name => event => {
    var today = new Date();
    var date = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();
    var last = new Date(today.getTime() - (event.target.value * 24 * 60 * 60 * 1000));
    //var privious_date = (last.getMonth() + 1) + '/' + last.getDate() + '/' + last.getFullYear();

    var privious_date = last.getFullYear() + '-' + (last.getMonth() + 1) + '-' + last.getDate();

    let early_morning = privious_date + ' 00:00';
    let early_datetimeparts = early_morning.split(' ');
    let early_timeParts = early_datetimeparts[1].split(':');
    let early_dateParts = early_datetimeparts[0].split('-');
    let early_date = new Date(parseInt(early_dateParts[0]), parseInt(early_dateParts[1], 10) - 1, parseInt(early_dateParts[2]), parseInt(early_timeParts[0]), parseInt(early_timeParts[1]));

    setState({
      ...state,
      [name]: event.target.value,
      deviceID: tank.deviceID,
      // durationDate: privious_date,
      durationDate: early_date.getTime(),
      selectedDate: event.target.value,
      isDisableSearchDuration: event.target.value === '' ? true : false,
      backgroundColorDuration: event.target.value === '' ? '#F4BFC1' : '#e20015',
      day: '',
      startSelected: '',
      endSelected: '',
      backgroundColorOneDay: '#F4BFC1',
      backgroundColorDateRange: '#F4BFC1',
      isDisableSearchOneDay: true,
      isDisableSearchDateRange: true
    });
  };

  // One day date change
  const handleDateChange = e => {
    let selectedDay = e.target.value;
    let early_morning = e.target.value + ' 00:00';
    let early_datetimeparts = early_morning.split(' ');
    let early_timeParts = early_datetimeparts[1].split(':');
    let early_dateParts = early_datetimeparts[0].split('-');
    let early_date = new Date(parseInt(early_dateParts[0]), parseInt(early_dateParts[1], 10) - 1, parseInt(early_dateParts[2]), parseInt(early_timeParts[0]), parseInt(early_timeParts[1]));
    let late_night = e.target.value + ' 23:59:59';
    let late_datetimeparts = late_night.split(' ');
    let late_timeParts = late_datetimeparts[1].split(':');
    let late_dateParts = late_datetimeparts[0].split('-');
    let late_date = new Date(parseInt(late_dateParts[0]), parseInt(late_dateParts[1], 10) - 1, parseInt(late_dateParts[2]), parseInt(late_timeParts[0]), parseInt(late_timeParts[1]));

    setState({
      ...state,
      day: selectedDay,
      deviceID: tank.deviceID,
      earlyDate: early_date.getTime(),
      lateDate: late_date.getTime(),
      isDisableSearchOneDay: e.target.value === '' ? true : false,
      backgroundColorOneDay: e.target.value === '' ? '#F4BFC1' : '#e20015',
      age: '',
      startSelected: '',
      endSelected: '',
      backgroundColorDuration: '#F4BFC1',
      backgroundColorDateRange: '#F4BFC1',
      isDisableSearchDuration: true,
      isDisableSearchDateRange: true
    })
  };

  // Date Range Start Date
  const handleStartDateRange = e => {
    let early_morning = e.target.value + ' 00:00';
    let early_datetimeparts = early_morning.split(' ');
    let early_timeParts = early_datetimeparts[1].split(':');
    let early_dateParts = early_datetimeparts[0].split('-');
    let early_date = new Date(parseInt(early_dateParts[0]), parseInt(early_dateParts[1], 10) - 1, parseInt(early_dateParts[2]), parseInt(early_timeParts[0]), parseInt(early_timeParts[1]));
    setState({
      ...state,
      startSelected: e.target.value,  // used to display on UI
      startDate: early_date.getTime(),  // passed as parameter to lambda
      isDisableSearchDateRange: e.target.value === '' ? true : false,
      backgroundColorDateRange: e.target.value === '' ? '#F4BFC1' : '#e20015',
      age: '',
      day: '',
      backgroundColorDuration: '#F4BFC1',
      backgroundColorOneDay: '#F4BFC1',
      isDisableSearchDuration: true,
      isDisableSearchOneDay: true
    })
  };

  // Date Range End Date
  const handleEndDateRange = e => {
    let late_night = e.target.value + ' 23:59:59';
    let late_datetimeparts = late_night.split(' ');
    let late_timeParts = late_datetimeparts[1].split(':');
    let late_dateParts = late_datetimeparts[0].split('-');
    let late_date = new Date(parseInt(late_dateParts[0]), parseInt(late_dateParts[1], 10) - 1, parseInt(late_dateParts[2]), parseInt(late_timeParts[0]), parseInt(late_timeParts[1]));
    setState({
      ...state,
      endSelected: e.target.value, // used to display on UI
      endDate: late_date.getTime(),  // passed as paramamter to lambda
      isDisableSearchDateRange: e.target.value === '' ? true : false,
      backgroundColorDateRange: e.target.value === '' ? '#F4BFC1' : '#e20015',
      age: '',
      day: '',
      backgroundColorDuration: '#F4BFC1',
      backgroundColorOneDay: '#F4BFC1',
      isDisableSearchDuration: true,
      isDisableSearchOneDay: true
    })
  };
  if (tank) {
    lastUpdated = tank.info.lastUpdated
    if (tank.type !== undefined && TRACKERTYPES.includes(tank.type.toString().toLowerCase()) && tank.location) {
      lastUpdated = tank.location.datetime
    }
  }
  return (
    <Grid container direction="column">
      <Grid container direction="row">
        <Grid container direction="column" item xs={12} sm={6} md={4}>
          <Box height="100%" py={{ xs: 4 }}>
            <Grid item>
              <Typography variant="h3" color="secondary">
                Status
              </Typography>
            </Grid>
            <Box
              height="100%"
              p={{ xs: 2 }}
              mt={{ xs: 1, md: 2 }}
              mr={{ xs: 0, md: 2 }}
              style={{ backgroundColor: '#fff' }}
            >
              <Grid container>
                <Grid item xs={6}>
                  <Gauge tank={tank} />
                </Grid>
                <Grid container direction="column" item xs={6} alignItems="center">
                  <Grid item>
                    <Box my={{ xs: 1 }}>
                      <ReadIcon tank={tank} />
                    </Box>
                  </Grid>
                  {tank.type !== 'pack' && (<Grid item>
                    <Box my={{ xs: 1 }}>
                      <Battery main tank={tank} />
                    </Box>
                  </Grid>)}
                  <Grid item>
                    <Box my={{ xs: 1 }}>
                      <Battery tank={tank} />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid container direction="column" item xs={12} sm={6} md={4}>
          <Box height="100%" py={{ xs: 4 }}>
            <Grid item>
              <Typography variant="h3" color="secondary">
                Details
              </Typography>
            </Grid>
            <Box
              height="100%"
              p={{ xs: 2 }}
              mt={{ xs: 1, md: 2 }}
              mr={{ xs: 0, md: 2 }}
              style={{ backgroundColor: '#fff' }}
            >
              <Grid item>
                {<Content label="Type" value={tank.type === 'blereader' ? 'BLE Reader' : toTitleCase(tank.type)} />}
              </Grid>
              <Grid item>
                <Box my={{ xs: 1 }}>
                  <Content label="Product" value={toTitleCase(tank.product)} />
                </Box>
              </Grid>
              <Grid item>
                <Box my={{ xs: 1 }}>
                  <Content label="Material#" value={toTitleCase(tank.productcode)} />
                </Box>
              </Grid>

              <Grid item>
                <Box my={{ xs: 1 }}>
                  <Content label="Tank ID" value={toTitleCase(tank.tankId)} />
                </Box>
              </Grid>

              {!TRACKERTYPES.includes(tank.type) && (
                <Grid item>
                  <Box my={{ xs: 1 }}>
                    <Content label="Capacity" value={`${tank.capacity || 0} ${tank.info.uom}`} />
                  </Box>
                </Grid>
              )}
              {((tank.type == "bulk" || (tank.info !== undefined && tank.info.data !== undefined && tank.info.data.type == 'bulk')) && (tank.info.data !== undefined && tank.info.data.sensor2 !== undefined)) && (
                <Grid item style={{ marginTop: 14 }}>
                  <Content label="Pressure" value={`${tank.info.data.sensor2.toFixed(2)} bar`} />
                </Grid>)}

              {(tank.type == "pack" && (tank.info.data !== undefined && tank.info.data.sensor1 !== undefined)) && (
                <Grid item style={{ marginTop: 14 }}>
                  <Content label="Pressure" value={`${tank.info.data.sensor1.toFixed(2) / 10} bar`} />
                </Grid>)}
              {!TRACKERTYPES.includes(tank.type) && (
                <Grid item>
                  <Box my={{ xs: 1 }}>
                    <Content
                      label="Remaining"
                      value={`${Math.round(tank.info.value * (tank.capacity || 0))} ${tank.info.uom}`}
                    />
                  </Box>
                </Grid>
              )}
              {TRACKERTYPES.includes(tank.type) && (
                <Grid item>
                  <Box my={{ xs: 1 }}>
                    <Content
                      label="Device id"
                      value={normaliseID(tank.deviceID)}
                    />
                  </Box>
                </Grid>
              )}
              {TRACKERTYPES.includes(tank.type) && (
                <Grid item>
                  <Box my={{ xs: 1 }}>
                    <Content
                      label="Size"
                      value={toTitleCase(tank.size)}
                    />
                  </Box>
                </Grid>
              )}
              {TRACKERTYPES.includes(tank.type) && (
                <Grid item>
                  <Box my={{ xs: 1 }}>
                    <Content
                      label="Cylinder#"
                      value={normaliseID(tank.equipment)}
                    />
                  </Box>
                </Grid>
              )}
              {TRACKERTYPES.includes(tank.type) && (
                <Grid item>
                  <Box my={{ xs: 1 }}>
                    <Content
                      label="Account #"
                      value={tank.sh}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item>
                <Box my={{ xs: 1 }}>
                  <Content label="Updated" value={lastUpdated == undefined ? '' : dateString(lastUpdated, true)} />
                </Box>
              </Grid>
              {!TRACKERTYPES.includes(tank.type) && (<Grid item>
                <Box my={{ xs: 1 }}>
                  <Content label="Address" value={tank.street || 'Unknown'} />
                </Box>
              </Grid>)}

              {(MOVABLETYPES.includes(tank.type) && tank.deliverydatetime !== undefined) && (<Grid item>
                <Box my={{ xs: 1 }}>
                  <Content label="Asset delivery date" value={dateString(tank.deliverydatetime)} />
                </Box>
              </Grid>)}


            </Box>
          </Box>
        </Grid>
        {!TRACKERTYPES.includes(tank.type) && (
          <Grid container direction="column" item xs={12} md={4}>
            <Box height="100%" py={{ xs: 4 }}>
              <Grid item>
                <Typography variant="h3" color="secondary">
                  Order
                </Typography>
              </Grid>
              <Box
                height="100%"
                p={{ xs: 2 }}
                mt={{ xs: 1, md: 2 }}
                mr={{ xs: 0, md: 2 }}
                style={{ backgroundColor: '#fff' }}
              >
                <Order tank={tank} />
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
      {geo && (
        <Grid container direction="column">
          {(TRACKERTYPES.includes(tank.type) || tank.type === 'pack') && (
            <Grid container direction="row" style={{ marginTop: 14 }} spacing={3}>
              <Grid item xs style={{ backgroundColor: "#fff", marginRight: 10, marginLeft: 10 }}>
                <span>Select Duration</span>
                <form autoComplete="off">
                  <FormControl >
                    <Select
                      native
                      value={state.age}
                      onChange={handleChange('age')}
                      inputProps={{
                        name: 'age',
                        id: 'age-native-simple',
                      }}
                    >
                      <option value="" />
                      <option value={7}>Last Week</option>
                      <option value={30}>Last Month</option>
                      <option value={90}>Last Three Month</option>
                      <option value={180}>Last Six Month</option>
                    </Select>
                  </FormControl>
                </form>

                <Grid item xs style={{ textAlign: "center", marginTop: "60px" }}>
                  <Button disabled={state.isDisableSearchDuration} style={{ width: '200px', borderRadius: 8, backgroundColor: state.backgroundColorDuration, color: 'white' }} onMouseOver={mouseOverColor('backgroundColorDuration')} onMouseLeave={resetColor('backgroundColorDuration')} onClick={btnSearchByDuration} >
                    <Typography>Search</Typography></Button>

                </Grid>

              </Grid>
              <Grid item xs style={{ backgroundColor: "#fff" }}>
                <TextField
                  id="date"
                  label="Select Date"
                  type="date"
                  name='selectdate'
                  onChange={handleDateChange}
                  value={state.day}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Grid item xs style={{ textAlign: "center", marginTop: "60px" }}>
                  <Button disabled={state.isDisableSearchOneDay} style={{ width: '200px', borderRadius: 8, backgroundColor: state.backgroundColorOneDay, color: 'white' }} onMouseOver={mouseOverColor('backgroundColorOneDay')} onMouseLeave={resetColor('backgroundColorOneDay')} onClick={btnSearchSingleDay} >
                    <Typography>Search</Typography></Button>
                </Grid>
              </Grid>
              <Grid item xs style={{ backgroundColor: "#fff", marginLeft: 10, marginRight: 28 }}>
                <span>Select Date Range</span>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container direction="row" style={{ marginTop: 14 }}>
                    <Grid item xs={6}>
                      <TextField
                        id="date"
                        label="From Date"
                        type="date"
                        name='selectdate'
                        onChange={handleStartDateRange}
                        value={state.startSelected}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} >
                      <TextField
                        id="date"
                        label="To Date"
                        type="date"
                        name='selectdate'
                        onChange={handleEndDateRange}
                        value={state.endSelected}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs style={{ textAlign: "center", marginTop: "25px" }}>
                    <Button disabled={state.isDisableSearchDateRange} style={{ width: '200px', borderRadius: 8, backgroundColor: state.backgroundColorDateRange, color: 'white' }} onMouseOver={mouseOverColor('backgroundColorDateRange')} onMouseLeave={resetColor('backgroundColorDateRange')} onClick={btnSearchBydateRange} >
                      <Typography>Search</Typography></Button>
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          )}

          {(TRACKERTYPES.includes(tank.type) || tank.type === 'pack') && (<Grid item style={{ textAlign: "center", marginTop: "37px" }}>
            <Button style={{ borderRadius: 8 }} onClick={btnReloadPage} >
              <Typography color="primary">Last known location</Typography></Button>
          </Grid>)}
          {/* <Box my={{ xs: 4, lg: 8, xl: 14 }}> */}
          <Grid item>
            <Typography variant="h4" color="secondary">
              Location
              </Typography>
          </Grid>
          <Grid item>
            <Box my={{ xs: 2 }}>
              {(noRecords || tank.location === undefined) ? <div>No Records found</div> : <Map geo={state.geo} type={tank.type} Map={GoogleMap} />}
            </Box>
          </Grid>
          {/* </Box> */}
        </Grid>
      )}
    </Grid>
  )
}
export default React.memo(Current)
